module.exports = __webpack_public_path__ + "static/media/straight.eb256214.svg";